/** @format */

import React, { FunctionComponent } from 'react';
import I18n from '../../components/Translate/I18n';
import { Typography } from '@material-ui/core';
import GetSubscription from '../../modules/plkFunctions/GetRequestSubscriptionDefault';
import MvnoOperation from '../../interfaces/platform/MvnoOperation';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { PlkField } from '../../modules/plkFunctions/PlkTypesInterface';
import SetClientDefault from '../../modules/plkFunctions/SetClientDefault';

interface PlkRequestViewInterface {
    getSubscription: GetSubscription | SetClientDefault;
    item: MvnoOperation;
    counter: number;
}

export const PlkRequestView: FunctionComponent<PlkRequestViewInterface> = ({ getSubscription, item, counter }) => {
    return (
        <GridContainer>
            <GridItem xs={12}>
                <Typography variant="subtitle2">
                    {counter + ' : '}
                    <I18n trans="prov:vb.request_parameter" />
                </Typography>
            </GridItem>
            {getSubscription.getRequestParameter(counter - 1).map((i: PlkField) => {
                if (i.key === 'createdAt') {
                    return (
                        <React.Fragment key={i.value + i.key}>
                            <GridItem xs={6}>
                                <I18n trans="prov:vb.block_start" />
                            </GridItem>
                            <GridItem xs={6}>{i.value}</GridItem>
                        </React.Fragment>
                    );
                } else {
                    return (
                        <React.Fragment key={i.value + i.key}>
                            <GridItem xs={6}>
                                <b>{i.key}</b>
                            </GridItem>
                            <GridItem xs={6}>{i.value}</GridItem>
                        </React.Fragment>
                    );
                }
            })}
        </GridContainer>
    );
};
